<template>
  <div>
    <head-nav-bar :title="title" :fixed="true" @click-left="tolist" />
    <div class="mt-header-nav user-form">
      <form-select
        label="客户类型"
        required
        :readonly="IsDisable"
        v-model="form.CustomerTypeId"
        :columns="CustomerTypeData"
      ></form-select>
      <van-field
        v-model="form.Code"
        :disabled="IsDisable"
        required
        clearable
        label="客户编号"
        placeholder="请输入客户编号"
      />
      <van-field
        v-model="form.Name"
        :disabled="IsDisable"
        required
        clearable
        label="客户名称"
        placeholder="请输入客户名称"
      />
      <van-field
        v-model="form.ShortName"
        :disabled="IsDisable"
        clearable
        label="简称"
        placeholder="请输入简称"
      />
      <van-field
        v-model="form.ContractNo"
        :disabled="IsDisable"
        clearable
        label="合同编号"
        placeholder="请输入合同编号"
      />
      <form-select
        label="销售员"
        required
        :readonly="IsDisable"
        v-model="form.SalesmanId"
        :columns="SalesmanData"
      ></form-select>
      <van-field
        v-model="form.Contacts"
        :disabled="IsDisable"
        clearable
        label="联系人"
        placeholder="请输入联系人"
      />
      <van-field
        v-model="form.ContactsInfo"
        :disabled="IsDisable"
        clearable
        label="联系电话"
        placeholder="请输入联系电话"
      />
      <form-select
        label="挂账标志"
        required
        :readonly="IsDisable"
        v-model="form.OfferCreditSign"
        :columns="OfferCreditSignData"
      ></form-select>
      <van-field
        type="number"
        v-model="form.TotalLimit"
        :disabled="IsDisable"
        clearable
        label="总限额"
        placeholder="请输入总限额"
      />
      <van-field
        type="number"
        v-model="form.SingleTimeLimit"
        :disabled="IsDisable"
        clearable
        label="单次限额"
        placeholder="请输入单次限额"
      />
      <van-field
        label="有效日期"
        required
        :style="disabledGroup ? 'background:#f9f9f9' : ''"
      >
        <template slot="input">
          <DateRangePicker
            :min="min"
            :max="max"
            :value.sync="form.daterange"
            :disabled="daterangeDisabled"
          ></DateRangePicker>
        </template>
      </van-field>
      <form-select
        label="价类"
        required
        v-model="form.PriceCodeId"
        :columns="PriceCodeData"
      ></form-select>
      <van-goods-action>
        <van-goods-action-button
          type="info"
          text="保存"
          style="width:100%"
          @click="onSubmit()"
        />
      </van-goods-action>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import { getOneUserDetail } from "@/api/user.js";
import formSelect from "@/components/form-select";
import { Add, Edit, EditGroup } from "@/api/user.js";
import { getSelectData, getGSelectData } from "@/api/common.js";
import { Field, Notify, GoodsAction, GoodsActionButton } from "vant";
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
export default {
  name: "editUser",
  components: {
    formSelect,
    DateRangePicker,
    [Field.name]: Field,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      id: 0,
      min: "",
      max: "",
      title: "",
      Salesman: "",
      disabledGroup: false,
      daterangeDisabled: {
        disabledStart: false,
        disabledEnd: false,
      },
      form: {
        CustomerTypeId: "",
        Code: "",
        Name: "",
        ShortName: "",
        ContractNo: "",
        Salesman: "",
        SalesmanId: "",
        Contacts: "",
        ContactsInfo: "",
        OfferCreditSign: "",
        TotalLimit: "",
        SingleTimeLimit: "",
        IsGroup: false,
        StartTime: "",
        EndTime: "",
        daterange: [],
        PriceCodeId: "",
      },
      IsDisable: false,
      PriceCodeData: [],
      SalesmanData: [],
      SalesmanGroupData: [],
      CustomerTypeData: [],
      CustomerGroupData: [],
      OfferCreditSignData: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.title = this.type == 1 ? "新增客户" : "编辑客户";
    this.min = this.user.AccountDate;
    this.max = moment(this.user.AccountDate)
      .add(1, "d")
      .format("YYYY-MM-DD");
    if (this.type == 1) {
      this.form.daterange = [
        this.user.AccountDate,
        moment(this.user.AccountDate)
          .add(1, "d")
          .format("YYYY-MM-DD"),
      ];
    }
    this.getData();
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  methods: {
    getData() {
      getGSelectData({
        Types: "Salesman",
        CompanyId: "10",
      }).then(res => {
        var _this = this;
        this.SalesmanGroupData = res.Data.Salesman;
        getSelectData({
          Types:
            "customertypecontainsgroup,CustomerType,salesman,OfferCreditSign,pricecode",
        }).then(res => {
          this.CustomerGroupData = res.Data.customertypecontainsgroup;
          this.CustomerTypeData = res.Data.CustomerType;
          this.SalesmanData = res.Data.salesman;
          this.OfferCreditSignData = res.Data.OfferCreditSign;
          this.PriceCodeData = res.Data.pricecode;
          if (this.type == 2 && this.id != undefined) {
            getOneUserDetail({ Id: this.id }).then(res => {
              _this.form = {
                ...res.Data,
                daterange: [],
              };
              _this.IsDisable = _this.form.IsGroup ? true : false;
              _this.daterangeDisabled = {
                disabledStart: _this.form.IsGroup ? true : false,
                disabledEnd: _this.form.IsGroup ? true : false,
              };
              _this.disabledGroup = _this.form.IsGroup ? true : false;
              _this.CustomerTypeData = this.form.IsGroup
                ? _this.CustomerGroupData
                : _this.CustomerTypeData;
              _this.SalesmanData = this.form.IsGroup
                ? _this.SalesmanGroupData
                : _this.SalesmanData;
              let daterange = [];
              daterange.push(_this.form.StartTime, _this.form.EndTime);
              _this.form.daterange = daterange;
            });
          }
        });
      });
    },
    verifyForm() {
      const verifyFields = [
        "CustomerTypeId",
        "Code",
        "Name",
        "SalesmanId",
        "OfferCreditSign",
        "daterange",
        "PriceCodeId",
      ];
      let is = false;
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i];
        if (!this.form[item]) {
          is = true;
        }
        if (item == "OfferCreditSign" && this.form[item] == 0) {
          is = false;
        }
      }
      if (is) {
        Notify("带*号必填，请完善信息！");
        return false;
      }
      return true;
    },
    onSubmit() {
      this.SalesmanData.forEach(item => {
        if (item.Id == this.form.SalesmanId) {
          this.form.Salesman = item.Text;
        }
      });
      const json = {
        ...this.form,
        StartTime: this.form.daterange[0],
        EndTime: this.form.daterange[1],
        Salesman: this.form.Salesman,
      };
      const verifyRes = this.verifyForm();
      if (verifyRes === false) {
        return false;
      }
      if (this.type == 1) {
        Add(json).then(() => {
          Notify({ type: "success", message: "新增成功" });
          this.$router.push({ name: "UserList" });
        });
      } else {
        if (this.IsDisable) {
          EditGroup({ Id: json.Id, PriceCodeId: json.PriceCodeId }).then(() => {
            Notify({ type: "success", message: "编辑成功" });
            this.$router.push({ name: "UserList" });
          });
        } else {
          Edit(json).then(() => {
            Notify({ type: "success", message: "编辑成功" });
            this.$router.push({ name: "UserList" });
          });
        }
      }
    },
    tolist() {
      this.$router.push({
        name: "UserList",
      });
    },
  },
};
</script>
<style lang="less">
.van-cell {
  .van-field__label {
    width: 1.9rem;
  }
}
.user-form {
  padding-bottom: 1.16667rem;
}
</style>
